import React, {useRef} from 'react'
import { FormattedMessage } from 'react-intl'
import {
  PageTitle,
  PageSubtitleWrapper,
  PageSubtitle,
  StyleLabel,
  StyleSubText,
  StyleUl,
  StyleLi,
  StyleTableContents,
  StyleLabelContent,
  BottomNavigation,
  NavigationLi
} from './style'
import Container from 'components/Container'
import Col from 'components/Col'
import Row from 'components/Row'
import ScrollToTop from 'components/ScrollToTop'
import {scrollDownToSection} from 'utils/scrollDownToSection'

const TermsAndUse = ({handleScroll = scrollDownToSection}) => {
  const section1 = useRef(null)
  const section2 = useRef(null)
  const section3 = useRef(null)
  const section4 = useRef(null)
  const section5 = useRef(null)
  const section6 = useRef(null)
  const section7 = useRef(null)
  const section8 = useRef(null)
  const section9 = useRef(null)
  const section10 = useRef(null)
  const section11 = useRef(null)
  const section12 = useRef(null)
  const section13 = useRef(null)

  return (
    <>
      <PageTitle data-test='legend'>
        <FormattedMessage id='termsPageTitle' />
      </PageTitle>
      <PageSubtitleWrapper data-test='sub-legend'>
        <PageSubtitle>
          <FormattedMessage id='termsPageSubTitle' />
        </PageSubtitle>
      </PageSubtitleWrapper>
      <Container data-testid='test-terms-use-container'>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel style={{paddingTop: '0'}} >
              <FormattedMessage id='introductionLabel' />
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='introductionSubText' values={{ linkTo: <a style={{color: '#202020'}} href={'https://www.ibat-alliance.org/'} target="_blank" rel="noreferrer"><b>Integrated Biodiversity Assessment Tool</b></a> }} />
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel style={{paddingBottom: '0'}}>
              <FormattedMessage id='tableOfContents' />
            </StyleLabel>
            <StyleTableContents>
              <StyleLabelContent data-testid='test-section1' onClick={() => {
                return handleScroll(section1)
              }} >
                <FormattedMessage id='generalLabel' />
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section2' onClick={() => {
                return handleScroll(section2)
              }}>
                <FormattedMessage id='intelectualLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section3' onClick={() => {
                return handleScroll(section3)
              }}>
                <FormattedMessage id='importantBirdLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section4' onClick={() => {
                return handleScroll(section4)
              }}>
                <FormattedMessage id='sensitiveDataLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section5' onClick={() => {
                return handleScroll(section5)
              }}>
                <FormattedMessage id='privacyLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section6' onClick={() => {
                return handleScroll(section6)
              }}>
                <FormattedMessage id='disclaimerLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section7' onClick={() => {
                return handleScroll(section7)
              }}>
                <FormattedMessage id='disclaimerOfWarrantyLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section8' onClick={() => {
                return handleScroll(section8)
              }}>
                <FormattedMessage id='indemnificationLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section9' onClick={() => {
                return handleScroll(section9)
              }}>
                <FormattedMessage id='terminationLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section10' onClick={() => {
                return handleScroll(section10)
              }}>
                <FormattedMessage id='changeManagementLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section11' onClick={() => {
                return handleScroll(section11)
              }}>
                <FormattedMessage id='governingLawLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section12' onClick={() => {
                return handleScroll(section12)
              }}>
                <FormattedMessage id='miscellaneousLabel'/>
              </StyleLabelContent>
              <StyleLabelContent data-testid='test-section13' onClick={() => {
                return handleScroll(section13)
              }}>
                <FormattedMessage id='contactLabel' />
              </StyleLabelContent>
            </StyleTableContents>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel style={{paddingTop: '32px'}} ref={section1}>
              <FormattedMessage id='generalLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='generalSubText1'/>
            </StyleSubText>
            <StyleUl>
              <StyleLi><FormattedMessage id="generalBullet1"/></StyleLi>
              <StyleLi><FormattedMessage id="generalBullet2"/></StyleLi>
              <StyleLi><FormattedMessage id="generalBullet3"/></StyleLi>
              <StyleLi><FormattedMessage id="generalBullet4"/></StyleLi>
              <StyleLi><FormattedMessage id="generalBullet5"/></StyleLi>
              <StyleLi><FormattedMessage id="generalBullet6"/></StyleLi>
            </StyleUl>
            <StyleSubText>
              <FormattedMessage id='generalSubText2' values={{ linkTo: <a style={{color: '#202020'}} href={'https://www.keybiodiversityareas.org/termsofservice'} target="_blank" rel="noreferrer"><b>KBA Data Terms and Conditions of Use</b></a>, linkTo2: <a style={{color: '#202020'}} href={'./pdf/KBAProposalProcess.pdf'} target="_blank" rel="noreferrer"><b>Key Biodiversity Areas Proposal Process: Guidance on Proposing, Reviewing, Nominating and Confirming sites</b></a> }}/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section2}>
              <FormattedMessage id='intelectualLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='intelectualSubText1' values={{ linkTo: <a style={{color: '#202020'}} href={'https://www.birdlife.org/'} target="_blank" rel="noreferrer"><b>BirdLife International</b></a> }}/>
            </StyleSubText>
            <StyleUl>
              <StyleLi><FormattedMessage id="intelectualBullet1" values={{ linkTo: <a style={{color: '#202020'}} href={'www.keybiodiversityareas.org'} target="_blank" rel="noreferrer"><b>www.keybiodiversityareas.org</b></a> }} /></StyleLi>
              <StyleLi><FormattedMessage id="intelectualBullet2"/></StyleLi>
              <StyleLi><FormattedMessage id="intelectualBullet3"/></StyleLi>
              <StyleLi><FormattedMessage id="intelectualBullet4"/></StyleLi>
              <StyleLi><FormattedMessage id="intelectualBullet5" values={{ linkTo: <a style={{color: '#202020'}} href={'https://www.ibat-alliance.org/'} target="_blank" rel="noreferrer"><b>Integrated Biodiversity Assessment Tool</b></a> }}/></StyleLi>
            </StyleUl>
            <StyleSubText>
              <FormattedMessage id='intelectualSubText2' />
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section3}>
              <FormattedMessage id='importantBirdLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='importantBirdSubText'/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section4}>
              <FormattedMessage id='sensitiveDataLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='sensitiveDataSubText' values={{ linkTo1: <a style={{color: '#202020'}} href={'https://portals.iucn.org/library/node/49131'} target="_blank" rel="noreferrer"><b>Guidelines for using A Global Standard for the Identification of KBAs</b></a>, linkTo2: <a style={{color: '#202020'}} href={'https://www.keybiodiversityareas.org/home'} target="_blank" rel="noreferrer"><b>KBA website</b></a> }}/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section5}>
              <FormattedMessage id='privacyLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='privacySubText' values={{ linkTo: <a style={{color: '#202020'}} href={'https://www.birdlife.org/privacy-policy/'} target="_blank" rel="noreferrer"><b>Privacy Policy</b></a> }} />
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section6}>
              <FormattedMessage id='disclaimerLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='disclaimerSubText'/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section7}>
              <FormattedMessage id='disclaimerOfWarrantyLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='disclaimerOfWarrantySubText'/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section8}>
              <FormattedMessage id='indemnificationLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='indemnificationSubText'/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section9}>
              <FormattedMessage id='terminationLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='terminationSubText' values={{ linkTo: <a style={{color: '#202020'}} href={'https://www.keybiodiversityareas.org/working-with-kbas/programme'} target="_blank" rel="noreferrer"><b>KBA Programe</b></a> }} />
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section10}>
              <FormattedMessage id='changeManagementLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='changeManagementSubText' />
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section11}>
              <FormattedMessage id='governingLawLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='governingLawSubText'/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section12}>
              <FormattedMessage id='miscellaneousLabel'/>
            </StyleLabel>
            <StyleSubText>
              <FormattedMessage id='miscellaneousSubText'/>
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <StyleLabel ref={section13}>
              <FormattedMessage id='contactLabel' />
            </StyleLabel>
            <StyleSubText style={{paddingBottom: '96px'}}>
              <FormattedMessage id='contactSubText' values={{ mailTo: <a style={{color: '#202020'}} href={'mailto:science@birdlife.org'}><b>science@birdlife.org</b></a> }} />
            </StyleSubText>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <BottomNavigation>
              <NavigationLi><a href='https://www.birdlife.org/privacy-policy/' target="_blank" rel="noreferrer">Privacy policy</a></NavigationLi>
            </BottomNavigation>
          </Col>
        </Row>
        <ScrollToTop />
      </Container>
    </>
  )
}

export default TermsAndUse

